import { Star } from "lucide-react";
import { REVIEWS } from "../../lib/data/reviews";
import { Reveal } from "../motion/Reveal";

// Reviews strip — deployed on every city detail page.
// Shape matches Google Places response so swapping to live API is trivial:
//   author -> author_name, rating -> rating, text -> text, role -> relative_time_description
// Swap the REVIEWS import for a fetch-once component when GOOGLE_PLACES_API_KEY
// is added to backend/.env — see docs in /app/frontend/src/lib/data/reviews.js
export default function ReviewsStrip({ cityName }) {
  return (
    <section
      className="bg-white border-y border-black/10 py-20 md:py-28"
      data-testid="reviews-strip"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 font-mono text-[10px] tracking-[0.28em] uppercase text-[#D92323]">
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={12} className="fill-[#D92323] text-[#D92323]" />
                ))}
              </div>
              5.0 · From BC Clients
            </div>
            <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95] text-[#060913]">
              {cityName ? `What ${cityName} clients say.` : "What BC clients say."}
            </h2>
          </div>
          <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#5C5F66] max-w-xs">
            Curated feedback from property managers, event producers, mining ops, and strata councils across BC.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {REVIEWS.map((r, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <article
                data-testid={`review-card-${i}`}
                className="border border-black/10 p-6 md:p-8 h-full flex flex-col justify-between hover:border-[#D92323] transition-colors bg-[#F4F4F0]"
              >
                <div>
                  <div className="flex gap-0.5 mb-4">
                    {[...Array(r.rating)].map((_, j) => (
                      <Star key={j} size={14} className="fill-[#D92323] text-[#D92323]" />
                    ))}
                  </div>
                  <p className="text-base md:text-lg text-[#060913] leading-relaxed">
                    "{r.text}"
                  </p>
                </div>
                <div className="mt-6 pt-4 border-t border-black/10">
                  <div className="font-display text-lg text-[#060913]">{r.author}</div>
                  <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#5C5F66] mt-1">
                    {r.role}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
